export default __webpack_public_path__ + "static/media/laundry2-after-768w.6dfbc09d.png";